import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Announces that an interaction was created, changed or deleted.
 *
 * The appbar's overdue badge outlives every page, so nothing that happens on one would
 * otherwise reach it -- closing the last overdue follow-up left the count sitting there
 * until a full reload. Anything that writes an interaction says so here; anything that
 * counts them listens.
 */
@Injectable({ providedIn: 'root' })
export class InteractionChangesService {
  private readonly changed = new Subject<void>();

  readonly changed$ = this.changed.asObservable();

  notify() {
    this.changed.next();
  }
}
